<template>

    <div class="w-full">

        <Card class="w-full mb-6">
            <template v-slot:header>
                Media Mail Creator
            </template>
            <template v-slot:body>
                <div class="p-6">
                    <div class="mb-4">
                        <label class="block text-grey-darkest font-bold mb-2">
                            Email Title
                        </label>
                        <input class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" type="text" v-model="title">
                    </div>
                    <div class="mb-4">
                        <label class="block text-grey-darkest font-bold mb-2">
                            Videos within the past hours
                        </label>
                        <input class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" type="number" v-model="hoursAgo">
                    </div>
                    <button class="px-2 py-1 rounded bg-blue-700 text-white" v-on:click="loadVideos">
                        <span v-if="!loading">Load Videos</span>
                        <span v-if="loading"><i class="fa fa-circle-o-notch fa-spin"></i></span>
                    </button>
                </div>
            </template>
        </Card>

        <CustomTable class="bg-white rounded shadow-md group">
			<template v-slot:header>
				<th class="bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light px-4 py-2">
                    <input type="checkbox" v-model="checkAll">
                </th>
				<th class="bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Video Details</th>
				<th class="bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light text-center" v-for="(network, index) in networks" :class="{'bg-gray-100': (index-1) % 2}">
                    <span :title="network.name" v-tippy>{{ network.name }}</span>
                </th>
			</template>
			<template v-slot:body>
				<tr class="hover:bg-grey-lighter" v-for="video in videos" v-if="!polling">
					<td class="border-b border-grey-light px-4 py-2">
                        <input type="checkbox" v-model="video.selected">
                    </td>
					<td class="border-b border-grey-light">
                        ${{ video.default_price }} - <strong>{{ video.title }}</strong> <br />
                        {{ video.created_at | displayLocalDateTime }} <br/>
                        Stringer: {{ video.stringer }}
                    </td>
                    <td class="border-b border-grey-light" v-for="(network, index) in networks" :class="{'bg-gray-100': (index-1) % 2}">
                        <input type="text" class="w-full border" v-model="video.price[network.id]">
                    </td>
				</tr>
			</template>
		</CustomTable>

        <button class="px-2 py-1 rounded bg-blue-700 text-white mt-5" v-on:click="sendMail">
            Send Mass Media Mail
        </button>

    </div>

</template>

<script>
    import { EventBus } from '@/utils/events'
    import * as Config from '@/config'
    import { mapState, mapGetters } from 'vuex'
    import moment from 'moment'

    import Card from '@/components/partials/Card'
    import CustomTable from '@/components/general/CustomTable'

	export default {
		name: 'MediaMailer',
		data () {
			return {
                videos: [],
                checkAll: true,
                networks: {},
                title: null,
                hoursAgo: 24,
                loading: false,

                polling: false,
			}
        },
        components: {
            Card,
            CustomTable
        },
        mounted() {
            this.getNationalNetworks();
            this.loadVideos();
        },
        methods: {
            ...mapGetters([
                'getAuthorizationHeader',
            ]),
            loadVideos() {
                var _this = this;
                this.loading = true;
                this.videos = [];

                this.$http.get(Config.apiPath + "/api/v2/admin/mail/available-videos?hoursAgo=" + this.hoursAgo, this.getAuthorizationHeader()).then((response) => {
                    var videos = response.data

                    for(var i=0; i<videos.length; i++) {

                        _this.videos.push({
                            id: videos[i].id,
                            title: videos[i].title,
                            created_at: videos[i].created_at,
                            stringer: videos[i].user.name,
                            default_price: videos[i].price,
                            selected: true,
                            price: {}
                        });

                    }

                    this.loading = false;
                
                });

            },

            getNationalNetworks() {
                var _this = this;
                this.$http.get(Config.apiPath + "/api/v2/admin/networks?type=national", this.getAuthorizationHeader()).then((response) => {
                    _this.networks = response.data
                });
            },

            sendMail() {
                if(this.title == null) {
                    this.$swal(
                        'Whoa, wait a minute!',
                        'Your mailing doesn\'t have a title! You better do that!',
                        'error'
                    )
                    return
                }

                var _this = this;
                this.$swal({
                    title: 'Are you sure?',
                    text: "You will not be able to cancel or edit this opperation!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, send the mail!'
                }).then((result) => {
                    if (result.value) {

                        //  only send videos that are selected by admin
                        var videosToSend = []

                        for(var i=0; i<this.videos.length; i++) {
                            if(this.videos[i].selected) {
                                videosToSend.push(this.videos[i]);
                            }
                        }

                        var data = {
                            title: this.title,
                            videos: videosToSend,
                        }

                        // send mail
                        this.$http.post(Config.apiPath + "/api/v2/admin/mail/media-mail", data, this.getAuthorizationHeader()).then((response) => {
                            
                            console.log(response.data)

                            _this.$swal(
                                'Sent!',
                                'Your mailing is being sent to media clients.',
                                'success'
                            )

                        });
                        
                    }
                })
            }
            
        },
        filters: {
            timecode: function(value) {
                if(value !== null) {
                    var seconds = Math.floor( value % 60 ).toString();
                    var minutes = Math.floor( value / 60 ).toString();
                    if( seconds.length === 1 ){
                        seconds = '0' + seconds;
                    }                
                    return minutes + ':' + seconds;
                }
            },
            displayLocalDateTime: function(date) {
                return moment.utc(date).local().format('MMMM Do YYYY, h:mm:ss a');
            }
        },
        watch: {
            checkAll: function(val) {
                if(val) {
                    for(var i=0; i<this.videos.length; i++) {
                        this.videos[i].selected = true;
                    }
                } else {
                    for(var i=0; i<this.videos.length; i++) {
                        this.videos[i].selected = false;
                    }
                }
            }
        }
	}
</script>

<style scoped>



</style>
